export enum BulkActionTypeModel {
	RebatesUpdate = 1,
	InOutpatientDefinitionsUpdate = 2,
	LocationsExcluding = 3
}
